export class EmailTemplate {
    oggetto: string;
    messaggio: string;
    descrizione: string;
    idTipologia: number;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/email-template.ts